import { createContext } from "react"
import { CustomerEmail } from "../../domain/customers/customer"

export type ActiveInvoicingModal = {
  modal: 'payInvoice' | 'sendInvoice'
  invoiceId: string
}

export type JobInvoicingContextData = {
  activeInvoicingModal: ActiveInvoicingModal | null
  setActiveInvoicingModal: (modal: ActiveInvoicingModal | null) => void
  customerEmails: CustomerEmail[]
}

const JobInvoicingContext = createContext<JobInvoicingContextData>({
  activeInvoicingModal: null,
  setActiveInvoicingModal: () => { },
  customerEmails: []
})

export default JobInvoicingContext